export default __webpack_public_path__ + "static/media/man-shrugging.fb2bbe39.png";